<div class="group/date">
    <div
        class="relative box-border flex h-[51px] flex-wrap items-center border-2 border-grey-400 transition-all group-hover/date:border-blue"
        [ngClass]="{
            'border-red': error(),
        }"
    >
        <button
            class="relative flex w-full flex-grow flex-col justify-center text-black outline-none"
            (click)="openOverlay($event)"
        >
            <span
                class="absolute bg-white leading-27 text-black transition-all duration-300 group-hover/date:text-blue"
                [ngClass]="{
                    '-top-14 left-0 px-12 text-12': control().value,
                    'px-16 text-16': !control().value,
                    'text-red': error(),
                }"
            >
                <ng-content />
            </span>
            @if (control().value; as v) {
                <span
                    class="absolute bg-white px-16 text-16 leading-27 text-black transition-all duration-300 group-hover/date:text-blue"
                >
                    {{ v | date: 'dd. MMMM YYYY' }}
                </span>
            }
            <i
                class="icon-calender absolute right-16 top-1/2 -translate-y-1/2 text-24 text-black transition-all duration-300 group-hover/date:text-blue"
                [ngClass]="{
                    'text-red': error(),
                }"
            ></i>
        </button>
    </div>
    <p class="leading-16 relative left-0 text-12 text-red">
        @if (!control().valid && control().value) {
            {{ errorValidation() }}
        }
        @if (control().touched && !control().valid && !control().value) {
            {{ errorRequired() }}
        }
    </p>
</div>
